import React, { useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Recipe } from 'public-contracts';
import { ModernRecipeList } from './ModernRecipeList';
import { ModernRecipeForm } from './ModernRecipeForm';
import { useNavigate } from 'react-router-dom';

export const ModernRecipeManagement: React.FC = () => {
  const { translate } = useTranslation();
  const navigate = useNavigate();
  const [formOpen, setFormOpen] = useState(false);
  const [editingRecipe, setEditingRecipe] = useState<Recipe | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const listRef = useRef<{ refresh: () => void }>(null);

  const handleCreateClick = () => {
    navigate('/recipes/create');
  };

  const handleEditClick = (recipe: Recipe) => {
    navigate(`/recipes/${recipe.id}/edit`);
  };

  return (
    <div className="container mx-auto p-6" data-testid="recipe-management">
      <ModernRecipeList
        key={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />
    </div>
  );
};

